// extracted by mini-css-extract-plugin
export default {"intro":"Forms_intro__vBriO","form":"Forms_form__GAAnk"};